import React, {useEffect} from 'react'
import { motion } from "framer-motion";
import { useTheme } from './ThemeContext';
import about from '../assets/about1.jpg';
import AOS from 'aos'
function About() {
  const { isDarkMode } = useTheme();

  useEffect(() =>
  {
      AOS.init({
          duration: 1000
      });
  })
  return (
    <section id='about' className={`py-12  ${isDarkMode ? 'dark' : ''}`}>
      <motion.div
        className="text-white mt-10 mx-auto text-center text-2xl dark:shadow-yellow-300 dark:shadow-lg font-extrabold bg-[#235191] 
          self-center lg:w-[292px] w-[200px] md:w-[250px] justify-center items-center   lg:py-4 py-2 md:py-3 rounded-[32px] max-md:mt-10 lg:px-5"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.5 }}
        transition={{ duration: 0.5 }}
        variants={{
          hidden: { opacity: 0, y: 50 },
          visible: { opacity: 1, y: 0 },
        }}

      >
        ABOUT
      </motion.div>
      <motion.div
        className="text-black dark:text-zinc-400 text-center text-2xl font-extrabold mx-auto mt-10 max-md:mt-10"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.5 }}
        transition={{ delay: 0.2, duration: 0.5 }}
        variants={{
          hidden: { opacity: 0, y: 50 },
          visible: { opacity: 1, y: 0 },
        }}
      >

        MISSION AND VISION
      </motion.div>
      <div data-aos="fade-up " className='flex flex-col lg:flex-row md:gap-6 mt-2 items-center px-10 md:px-20 lg:px-24 '>
        <div
          className="about  text-zinc-600 dark:text-gray-300 lg:text-3xl sm:text-xl md:text-2xl text-justify "
        
        >
          Join us for an unbeatable entry test prep experience! Ace your exams with our top-notch mock tests,
          crafted from recent papers and common MCQs. Get ready to secure your spot in the 24th batch
          hassle-free!" Let us guide you towards securing your seat in the 24th batch with confidence and ease! Step into success with confidence,
          backed by our proven track record of guiding students to their academic goals.

        </div>
        <div>
          <img src={about} alt='about' className='md:w-[3000px] text-cyan-400 md:h-[450px] rounded-md lg:w-[2800px] lg:h-[320px]' />
        </div>
      </div>
    </section>
  )
}

export default About
